import Model from '@/models/Model.js';

export default class FlashcardActivity extends Model {
    static entity = 'flashcard_activities';

    static modelName = 'FlashcardActivity';

    static fields() {
        return {
            content: this.attr(null),
            flashcard_set_id: this.attr(null),

            ...super.fields(),
        };
    }
}
